import { useQuery } from "react-query";

import axios from "../../../../utils/authAxios";

const apiBaseUrl =
    process.env.REACT_APP_API_BASEURL +
    "/BusinessLicensePermits";

export interface BLPTypeOptionDto {
  busLicensePermitTypeId: number;
  busLicensePermitTypeName: string;
}

export interface BLPIssuerOptionDto {
  issuer: number;
  issuerName: string;
}

export interface BLPPermitNumberOptionDto {
  licenseOrPermitNumber: string;
}

export interface BLPStoreNumberOptionDto {
  storeNumber: string;
}

export interface BLPLicenseStatusOptionDto {
  licenseStatusId: number;
  licenseStatusName: string;
}

export interface BLPTableFilterOptionsResponse {
  types: BLPTypeOptionDto[];
  issuers: BLPIssuerOptionDto[];
  licenseOrPermitNumbers: BLPPermitNumberOptionDto[];
  storeNumbers: BLPStoreNumberOptionDto[];
  licenseStatuses: BLPLicenseStatusOptionDto[];
}

interface BLPTableFilterOptionsApiResponse {
  types?: BLPTypeOptionDto[];
  Types?: BLPTypeOptionDto[];

  issuers?: BLPIssuerOptionDto[];
  Issuers?: BLPIssuerOptionDto[];

  licenseOrPermitNumbers?: BLPPermitNumberOptionDto[];
  LicenseOrPermitNumbers?: BLPPermitNumberOptionDto[];

  storeNumbers?: BLPStoreNumberOptionDto[];
  StoreNumbers?: BLPStoreNumberOptionDto[];

  licenseStatuses?: BLPLicenseStatusOptionDto[];
  LicenseStatuses?: BLPLicenseStatusOptionDto[];
}

export const getBLPTableFilterOptions =
  async (): Promise<BLPTableFilterOptionsResponse> => {
      const response =
          await axios.get<BLPTableFilterOptionsApiResponse>(
      `${apiBaseUrl}/TableFilterOptions`
    );

    const result = response.data;

    return {
      types: result.types ?? result.Types ?? [],

      issuers: result.issuers ?? result.Issuers ?? [],

      licenseOrPermitNumbers:
        result.licenseOrPermitNumbers ?? result.LicenseOrPermitNumbers ?? [],

      storeNumbers: result.storeNumbers ?? result.StoreNumbers ?? [],

      licenseStatuses: result.licenseStatuses ?? result.LicenseStatuses ?? [],
    };
  };

export const useGetBLPTableFilterOptions = () => {
    return useQuery(
        ["GetBLPTableFilterOptions"],
        getBLPTableFilterOptions,
        {
    refetchOnWindowFocus: false,
        }
    );
};